import { render } from "./VUEAppContentSchedaMessaggi.vue?vue&type=template&id=7fb6f65a"
import script from "./VUEAppContentSchedaMessaggi.vue?vue&type=script&lang=js"
export * from "./VUEAppContentSchedaMessaggi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__